import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//img/question-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-fdb189ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-test-wrapper test-wrapper" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "user-card" }
const _hoisted_4 = { class: "user-card__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "user-card__img"
}, null, -1))
const _hoisted_6 = { class: "user-card__caption" }
const _hoisted_7 = ["disabled"]

import { useTestStore } from "@/store/UserTestModule";
import { computed, onUnmounted, ref } from "vue";

import SimpleQuestionComponent from "@/components/questionTypes/SimpleQuestionComponent.vue";
import CorrespondenceQuestionComponent from "@/components/questionTypes/CorrespondenceQuestionComponent.vue";
import OrderQuestionComponent from "@/components/questionTypes/OrderQuestionComponent.vue";

import UserApi from "../api/UserApi";
import ITest from "@/interfaces/ITest";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TestQuestionsComponent',
  setup(__props) {

const testStore = useTestStore();
const api = new UserApi();
const questions = ref(testStore.questions);
const currentQuestion = computed(() => {
  if (testStore.currentQuestion != null) {
    return testStore.currentQuestion;
  } else {
    return questions.value[testStore.currentQuestionNumber];
  }
});
const simpleComponent = ref();
const correspondenceComponent = ref();
const orderComponent = ref();
const isSendDisabled = ref(false);

const isNextDisabled = computed(() => {
  if (simpleComponent.value) {
    return simpleComponent.value.isNextDisabledSimple || isSendDisabled.value;
  } else if (orderComponent.value) {
    return orderComponent.value.isNextDisabledOrder || isSendDisabled.value;
  } else if (correspondenceComponent.value) {
    return correspondenceComponent.value.isNextDisabledCorrespondence || isSendDisabled.value;
  } else {
    return true;
  }
});

const isNextText = computed(() => {
  if (testStore.currentQuestionNumber + 1 === questions.value.length) {
    return "Завершить тест";
  } else {
    return "Следующий вопрос";
  }
});

/* Navigates to the next question in the test.*/
async function goToNext() {
  if (testStore.currentQuestionNumber + 1 === questions.value.length) {
    isSendDisabled.value = true;
    const testset = await api.loadTest(testStore.testId);
    testset.questionForUsers = testStore.userAnswers;
    await api.saveTestResult(testset).catch((err) => {
      isSendDisabled.value = false;
      router.push("/user");
    });
    router.push("/user");
  } else {
    testStore.setCurrentQuestionNumber(testStore.currentQuestionNumber + 1);
  }
}

onUnmounted(() => {
  testStore.$reset();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, " Вопрос " + _toDisplayString(_unref(testStore).currentQuestionNumber + 1) + " из " + _toDisplayString(questions.value.length), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("h2", _hoisted_6, _toDisplayString(currentQuestion.value.text), 1)
      ]),
      (currentQuestion.value.questionTypeId === 3)
        ? (_openBlock(), _createBlock(OrderQuestionComponent, {
            key: 0,
            ref_key: "orderComponent",
            ref: orderComponent
          }, null, 512))
        : (currentQuestion.value.questionTypeId === 4)
          ? (_openBlock(), _createBlock(CorrespondenceQuestionComponent, {
              key: 1,
              ref_key: "correspondenceComponent",
              ref: correspondenceComponent
            }, null, 512))
          : (_openBlock(), _createBlock(SimpleQuestionComponent, {
              key: 2,
              ref_key: "simpleComponent",
              ref: simpleComponent
            }, null, 512)),
      _createElementVNode("button", {
        class: "base-btn base-btn-yellow",
        disabled: isNextDisabled.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToNext()))
      }, _toDisplayString(isNextText.value), 9, _hoisted_7)
    ])
  ]))
}
}

})